import Axios from 'axios';
import i18n from 'i18next';
import { toast } from 'react-toastify';

type TAlarmEventType = string;

interface TLaurent2EventConfig {
  event_type: TAlarmEventType;
  relay: number;
}

export interface TLaurent2Config {
  ip: string;
  password?: string;
  delay?: number;
  events: TLaurent2EventConfig[];
}

export interface Laurent2AlarmParams {
  eventType: TAlarmEventType;
  laurent2Config: TLaurent2Config;
}

export const isValidLaurent2Config = (
  config: Partial<TLaurent2Config> | null | undefined,
  eventType: TAlarmEventType | undefined,
): boolean => {
  if (
    !config?.ip
    || !Array.isArray(config?.events)
    || !eventType
  ) {
    return false;
  }

  const event = config.events.find((e) => (
    e?.event_type === eventType
    && typeof e.relay === 'number'
  ));

  return Boolean(event);
};

const getLaurentUrl = (config: TLaurent2Config, eventType: TAlarmEventType): string => {
  const event = config.events.find((e) => e.event_type === eventType);
  if (!event) throw new Error(`Laurent2 event config not found for event type "${eventType}"`);

  const relayId = event.relay; // possible values - 1,2,3,4
  const relayState = 1; // 0 - off, 1 - on
  const cmdValues: (string | number)[] = [
    'REL',
    relayId,
    relayState,
  ];
  if (config?.delay) {
    let relayDelay: string | number = config.delay;
    if (config.delay < 1) relayDelay = String(relayDelay).substring(1);
    else relayDelay = Math.floor(relayDelay);
    cmdValues.push(relayDelay);
  }
  const cmd = cmdValues.join(',');
  const pswPart = config.password ? `&psw=${config.password}` : '';

  return `http://${config.ip}/cmd.cgi?cmd=${cmd}${pswPart}`;
};

export async function sendLaurent2Alarm({
  eventType,
  laurent2Config,
}: Laurent2AlarmParams): Promise<void> {
  const laurentUrl = getLaurentUrl(laurent2Config, eventType);

  const { data } = await Axios.get(laurentUrl);

  if (data.includes('#ERR')) {
    toast.error(i18n.t('features:alarm_button.error'));
    throw new Error();
  }

  toast.success(i18n.t('features:alarm_button.success'));
}
